import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFolderView } from '../models/vdr-folder-view.model';
import { SourceType } from '../models/vdr-access-permission.model';

export interface FetchDataRoomRequest {
    sourceId: number;
    sourceType: SourceType;
}

export const FetchDataRoom = createAsyncThunk(
    'dataRoom/fetchDataRoom',
    async (
        { sourceId, sourceType }: FetchDataRoomRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.get(
                `api/VirtualDataRooms/${sourceId}?sourceType=${sourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch data room structure at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch data room structure');
            }

            return response.data as VDRFolderView;
        } catch (error) {
            createNotification(
                'An error occurred while fetching data room structure.',
                'error'
            );
            throw error;
        }
    }
);
